import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from 'src/app/components/components.module';
import { SubscriptionOverviewComponent } from './subscription-overview/subscription-overview.component';
import { SubscriptionCardComponent } from './_components/subscription-card/subscription-card.component';

@NgModule({
  declarations: [
    SubscriptionOverviewComponent,
    SubscriptionCardComponent
  ],
  imports: [
    CommonModule,
    ComponentsModule,
  ],
  exports: [
    SubscriptionOverviewComponent,
    SubscriptionCardComponent
  ]
})
export class SubscriptionModule { }
